<template>
  <div :class="componentClassName">
    <a-brand-logo variant="horizontal" class="t-error__logo" />
    <div class="t-error__content">
      <div class="t-error__image">
        <img src="@/images/pages/404.svg" />
      </div>
      <a-heading :heading="title" color="primary" size="large" class="t-error__heading" />
      <a-text :center="true" class="t-error__text">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div style="text-align: left" v-html="message" />
      </a-text>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import ABrandLogo from '@/components/atoms/brand-logo';
import AButton from '@/components/atoms/button';
import AHeading from '@/components/atoms/heading';
import AText from '@/components/atoms/text';

export default {
  name: 't-error',
  components: {
    ABrandLogo,
    //AButton,
    AHeading,
    AText,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    //title: {
    //  type: String,
    //  default: '',
    //},
    //message: {
    //  type: String,
    //  default: '',
    //},
  },
  data() {
    return {
      title: '認証リンクはコード認証に切り替わりました。',
      message: `再度ログイン画面でログインするとお客様のメールアドレス宛に認証コードが送信されます。<br>
認証コード入力画面で認証コードを入力することで、ログインを完了させることができます。<br>
ログイン画面の「※パスワードをお忘れになった方は こちら」からパスワードを再設定ください。<br>
ログイン画面：<a href="https://cotohacc.vdxp-sys.com/login">https://cotohacc.vdxp-sys.com/login</a>`,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-error');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleGoToHome() {
      window.location.href = '/';
    },
  },
};
</script>
